import app from 'flarum/forum/app';
import SpeciesPage from './SpeciesPage';
import SpeciesSearchWidget from './SpeciesSearchWidget';
import speciesName from '../utils/speciesName';
import { speciesClassificationBox } from './SpeciesInfoBoxes';

/**
 * /taxon/:id - the Catalogue of Life-flavored counterpart of SpeciesPage's
 * own /species/:id, mirroring GBIF's own site (https://www.gbif.org/species/
 * for its own Backbone Taxonomy vs. https://www.gbif.org/taxon/ for an
 * entry sourced from another checklist, e.g. Catalogue of Life). `:id` is a
 * COL id (e.g. "5TYZ9" - see ChecklistBankClient's own docblock), fetched
 * via TaxonResource (GET /api/taxon/:id) instead of SpeciesResource.
 *
 * A visitor lands here one of two ways: SpeciesPage's own client-side
 * redirect (see its loadSpecies()), for a real champis.net species with a
 * resolved col_id - renders exactly like SpeciesPage itself (inherited
 * view(), untouched) since GbifSpeciesRecord.id is always the gbif_id
 * regardless of which route fetched it (see TaxonResource's own docblock).
 * Or a classification-box link (speciesClassificationBox(), see its own
 * *ColId-based href) to a genus/family/order/... with no gbif_id at all -
 * SpeciesPage's own loadSpecies() sets `colTaxon` (never `species`) for
 * that case (see its own docblock), and view() below renders a much
 * thinner layout for it: no discussions/gallery/keys/synonyms/references,
 * every one of those is inherently gbif_id-scoped and there simply isn't
 * one.
 */
export default class TaxonPage extends SpeciesPage {
  source = 'taxon';
  view() {
    if (!this.colTaxon) {
      return super.view();
    }
    const s = this.colTaxon;
    return m("div", {
      className: "Page SpeciesPage"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "SpeciesPage-header"
    }, s.rank && m("p", {
      className: "SpeciesPage-badges"
    }, s.rank.toUpperCase()), m("h1", null, speciesName(s))), m("p", {
      className: "helpText"
    }, app.translator.trans('champis-species.forum.species_page.col_taxon_notice')), m("div", {
      className: "Page-container"
    }, m("div", {
      className: "Page-content"
    }), m("div", {
      className: "Page-sidebar"
    }, m(SpeciesSearchWidget, null), speciesClassificationBox(s)))));
  }
}
flarum.reg.add('champis-species', 'forum/components/TaxonPage', TaxonPage);